var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnAlgorithmBlock = function SvgIcnAlgorithmBlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentcolor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12 2.44772 12.4477 2 13 2H19C19.5523 2 20 2.44772 20 3V9C20 9.55228 19.5523 10 19 10H17V15H27C28.1046 15 29 15.8954 29 17V22H31C31.5523 22 32 22.4477 32 23V29C32 29.5523 31.5523 30 31 30H25C24.4477 30 24 29.5523 24 29V23C24 22.4477 24.4477 22 25 22H27V17H17V22H19C19.5523 22 20 22.4477 20 23V29C20 29.5523 19.5523 30 19 30H13C12.4477 30 12 29.5523 12 29V23C12 22.4477 12.4477 22 13 22H15V17H5V22H7C7.55228 22 8 22.4477 8 23V29C8 29.5523 7.55228 30 7 30H1C0.447715 30 0 29.5523 0 29V23C0 22.4477 0.447715 22 1 22H3V17C3 15.8954 3.89543 15 5 15H15V10H13C12.4477 10 12 9.55228 12 9V3Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnAlgorithmBlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_algorithm_block.94c7db68.svg";
export { ForwardRef as ReactComponent };